(function () {
    window.c24.lp.message = {
        delayTyping: 150,
        charDelay: 21,
        spaceDelay: 32,
        nextBubbleDelay: 150,

        activationTrigger: null,
        activationOffset: null,
        element: null,
        target: null,
        inProgress: null,

        started: false,
        text: '',
        textIndex: 0,
        next: null,

        init: function (element, activationTrigger, activationOffset) {
            const message = window.c24.lp.message;

            message.activationTrigger = activationTrigger;
            message.activationOffset = activationOffset;
            message.element = element;
            message.target = $('.target', element);
            message.target.html(
                '<div class="div24Loading"><span></span><span></span><span></span></div>',
            );
            message.inProgress = $('.inprogress', element);

            message.started = false;
            message.text = element.data('text');
            message.textIndex = 0;
            message.next = element.data('next');

            message.testStart();
            $(document).on('scroll', function () {
                message.testStart();
            });
        },

        testStart: function () {
            const message = window.c24.lp.message;

            if (message.started === false) {
                if (!message.activationTrigger) {
                    message.start();
                } else {
                    const scrollPosition =
                        message.activationTrigger.offset().top +
                        message.activationOffset;
                    if (
                        scrollPosition > $(window).scrollTop() &&
                        scrollPosition <
                            $(window).scrollTop() + $(window).height()
                    ) {
                        message.start();
                    }
                }
            }
        },

        start: function () {
            const message = window.c24.lp.message;

            message.started = true;
            message.element.animate(
                {
                    width: 'toggle',
                },
                800,
                function () {
                    setTimeout(message.startTyping, message.delayTyping);
                },
            );
        },

        startTyping: function () {
            const message = window.c24.lp.message;

            const loadingEle = $('.div24Loading', message.target);
            loadingEle.stop().fadeOut('slow', function () {
                loadingEle.remove();
                message.typeNext();
            });
        },

        typeNext: function () {
            const message = window.c24.lp.message;

            message.target.append(message.text[message.textIndex]);
            message.textIndex++;
            if (message.textIndex < message.text.length) {
                setTimeout(
                    message.typeNext,
                    message.text[message.textIndex] == ' '
                        ? message.spaceDelay
                        : message.charDelay,
                );
            } else {
                message.inProgress.stop().fadeOut('slow', function () {
                    message.inProgress.remove();
                    if (message.next) {
                        const next = $('#' + message.next);
                        if (next.length == 1) {
                            setTimeout(function () {
                                message.init(next, null, 0);
                            });
                        }
                    }
                });
            }
        },
    };

    $(document).ready(function () {
        // new URLSearchParams() doesnt work in IE, so this is the workaround

        $.urlParam = function (name) {
            const results = new RegExp('[?&]' + name + '=([^&#]*)').exec(
                window.location.href,
            );
            if (results == null) {
                return null;
            } else {
                return decodeURI(results[1]) || 0;
            }
        };

        const _sInsuranceCompany = $.urlParam('InsuranceCompany');
        const _sProductName = $.urlParam('ProductName');

        if (_sInsuranceCompany && _sProductName) {
            $('#insuranceCompany', '#c24EmailChangedText')
                .empty()
                .text(_sInsuranceCompany);
            $('#productName', '#c24EmailChangedText')
                .empty()
                .text(_sProductName);
            $('.js24OverlayLink').click();
        }

        $('.c24Link', '#c24EmailChangedText').click('on', function () {
            parent.$.fancybox.close();
        });

        $('.appstore', '.mod24ac.cta').on('click', function () {
            window._paq.push([
                'trackEvent',
                'landing_page_vc',
                'lp_appstore_clicked',
            ]);
        });

        $('.googleplay', '.mod24ac.cta').on('click', function () {
            window._paq.push([
                'trackEvent',
                'landing_page_vc',
                'lp_playstore_clicked',
            ]);
        });

        $('.c24Button.box24Login.js24OpenLoginLayer', '.mod24ac.cta').on(
            'click',
            function () {
                window._paq.push([
                    'trackEvent',
                    'landing_page_vc',
                    'lp_versicherungscenter_clicked',
                ]);
            },
        );

        $('.c24Button.js24LoadingToggle', '.mod24ac.cta').on(
            'click',
            function () {
                window._paq.push([
                    'trackEvent',
                    'landing_page_vc',
                    'lp_versicherungscenter_clicked',
                ]);
            },
        );

        const vcSetButtons = {
            ueberblick: {
                e_c: 'landing_page_vc', // eslint-disable-line
                e_a: 'lp_vertragsuebersicht_clicked', // eslint-disable-line
            },
            bedarfscheck: {
                e_c: 'landing_page_vc', // eslint-disable-line
                e_a: 'lp_bedarf_clicked', // eslint-disable-line
            },
            rentencheck: {
                e_c: 'landing_page_vc', // eslint-disable-line
                e_a: 'lp_rentenluecke_clicked', // eslint-disable-line
            },
            vertragscheck: {
                e_c: 'landing_page_vc', // eslint-disable-line
                e_a: 'lp_vertragpruefen_clicked', // eslint-disable-line
            },
            beratung: {
                e_c: 'landing_page_vc', // eslint-disable-line
                e_a: 'lp_service_clicked', // eslint-disable-line
            },
        };

        handleQuickchips();

        $.each(vcSetButtons, function (index, value) {
            const vsButtonObject = $('.' + index + ' a');

            $(vsButtonObject).on('click', function () {
                window._paq.push([
                    'trackEvent',
                    value.e_c,
                    value.e_a,
                    'landing_page_vc',
                ]);
            });
        });

        function handleQuickchips() {
            const quickchipsContainer = document.querySelector(
                '.lp-c24-quickchips-chips',
            );
            if (!quickchipsContainer) {
                return;
            }

            // Lazy-load items for better initial load performance
            let quickchipsItems = null;

            // Ensure only fully visible items are shown on resize
            function adjustQuickchips() {
                // Calculate and sort items once on first call
                if (!quickchipsItems) {
                    quickchipsItems = Array.from(
                        quickchipsContainer.querySelectorAll(
                            '.lp-c24-quickchips-link:not(.lp-c24-quickchips-all-insurances)',
                        ),
                    );
                }

                // Show all items
                quickchipsItems.forEach(function (item) {
                    item.style.removeProperty('display');
                });

                // Use clientWidth and scrollWidth for more accurate measurements
                const containerWidth = quickchipsContainer.clientWidth;
                let scrollWidth = quickchipsContainer.scrollWidth;

                // If not enough space, hide items one by one from the end
                while (scrollWidth > containerWidth) {
                    const visible = quickchipsItems.filter(function (item) {
                        return item.style.display !== 'none';
                    });
                    if (!visible.length) break;
                    visible[visible.length - 1].style.display = 'none';
                    scrollWidth = quickchipsContainer.scrollWidth;
                }
            }

            adjustQuickchips();

            // Debounce resize observer for better performance
            let resizeTimeout;
            new ResizeObserver(function () {
                if (resizeTimeout) return;
                resizeTimeout = setTimeout(function () {
                    adjustQuickchips();
                    resizeTimeout = null;
                }, 100);
            }).observe(quickchipsContainer);
        }

        setTimeout(function () {
            if ($('#chatQuestion').length) {
                window.c24.lp.message.init(
                    $('#chatQuestion'),
                    $('.mod24Flat .beratung'),
                    240,
                );
            }
        }, 2000);
    });
})();
